<template>
  <div class="event-information">
    <Section>
      <Headline size="3">Event Information</Headline>

      <div class="event-information-fields row">
        <div class="col-md-12">
          <InputDropdownMultiselect
            class="inputWrapper"
            placeholder="Select matchday"
            :options="matchDaysList"
            trackLabel="optionLabel"
            trackBy="matchdayId"
            group-select
            group-values="items"
            group-label="label"
            :multiple="true"
            :limit="1"
            label="Matchday"
            v-model="matchDay"
            keepOpen
          />

          <InputDropdownMultiselect
            class="inputWrapper"
            placeholder="Select match"
            :disabled="!matchDay || !matchDay.length"
            :options="matchesList"
            trackLabel="name"
            trackBy="matchId"
            group-select
            group-values="items"
            group-label="label"
            :multiple="true"
            :limit="1"
            label="Match"
            v-model="match"
            keepOpen
          />
        </div>

        <table v-if="match && match.length" class="match-info-table">
          <thead>
          <tr>
            <th>Match</th>
            <th>Matchday</th>
            <th>Venue</th>
            <th>Match Kick-off Time (UTC+8)</th>
            <th>
              <Button
                class="button-delete"
                type="round"
                icon="BIN_OUTLINE"
                title="Clear selections"
                @click="clearSelections"
              />
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="m in match" :key="m.matchId">
            <td>{{ m.name }}</td>
            <td>{{ m.matchday ? m.matchday.optionLabel : '' }}</td>
            <td>{{ m.venue ? m.venue.localTitle : '' }}</td>
            <td>{{ getMatchKickoffTime(m.startDateTime) }}</td>
            <td>
              <Button
                class="button-delete"
                type="round"
                icon="BIN_OUTLINE"
                @click="removeMatch(m)"
              />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </Section>

    <div class="btn-wrapper">
      <Button
        :disabled="!matchDay || !matchDay.length || !match || !match.length"
        type="primary"
        @click="changeTab('ActivationInfo')"
      >
        Continue
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button/Button.component";
import Headline from "@/components/Headline/Headline.component";
import InputDropdownMultiselect from '@/components/Inputs/InputDropdownMultiselect.component.vue';
import Section from '@/components/Section/Section.component';

import get from "lodash.get";
import moment from "moment";

export default {
  name: "AccreditationEventInformation.view",
  components: {
    Button,
    Headline,
    InputDropdownMultiselect,
    Section
  },
  data: () => ({}),
  computed: {
    matchDaysList() {
      const matchDays = get(this, '$store.state.event.matchDaysList') || []
      return [
        {
          label: 'All matchdays',
          items: matchDays
        },
      ]
    },
    matchesList() {
      const matches = get(this, '$store.state.event.matchesList') || []
      return [
        {
          label: 'All matches',
          items: matches
        },
      ]
    },
    matchDay: {
      get: function () { return this.$store.state.sponsorActivation.eventInfo.matchDay },
      set: function (newVal) { this.$store.state.sponsorActivation.eventInfo.matchDay = newVal }
    },
    match: {
      get: function () { return this.$store.state.sponsorActivation.eventInfo.match },
      set: function (newVal) { this.$store.state.sponsorActivation.eventInfo.match = newVal }
    },
  },
  watch: {
    matchDay(newVal) {
      if(newVal && newVal.length) {
        const matchdayIds = newVal.map(md => md.matchdayId)
        this.getMatches({ matchdayIds })
        this.match = (this.match || []).filter(m => matchdayIds.includes(m.matchday?.matchdayId))
      } else {
        this.match = []
      }
    },
  },
  methods: {
    getMatches(data) { this.$store.dispatch('event/getMatches', {...data, requestType: 'sponsor_activation_request'}) },
    changeTab(tab) {
      this.$emit('tabchange', tab)
    },
    getMatchKickoffTime(startDateTime) {
      return moment(startDateTime).add(8, 'hours').format('DD.MM.YYYY HH:mm')
    },
    removeMatch(matchToRemove) {
      this.match = (this.match || []).filter(m => m.matchId !== matchToRemove.matchId)
    },
    clearSelections() {
      this.matchDay = []
      this.match = []
    },
  },
  created() {
    this.$store.dispatch('event/getMatchDays', {hasMatchesForActivationRequest: 1})
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/mixins/ellipsis.mixin";
@import "../../../../styles/mixins/radio.mixin";

.event-information {
  font-size: 12px;

  .match-info-table {
    width: 100%;
    margin-top: 16px;
    border-collapse: collapse;
    font-size: 12px;

    thead {
      background-color: #d8dae3;
    }

    th, td {
      padding: 12px 10px;
      text-align: left;
      border-bottom: 1px solid #D8DAE3;
    }

    th {
      font-weight: bold;
    }

    .button-delete {
      height: auto !important;
      background: none;

      ::v-deep .button-component__icon {
        color: #dc3545 !important;
        transform: none;
      }
    }
  }

  @include radio();
  .radio-group {
    display: flex;

    > div {
      margin-right: 40px;
    }
  }

  .paragraph-component {
    color: #383838;
  }

  .InputDropdown {
    margin-bottom: 20px;
  }

  .inputWrapper {
    max-width: 800px;
  }

  .btn-wrapper {
    width: 100%;
    text-align: right;
  }

  ::v-deep .InputLabel__label {
    @include ellipsis;
    min-width: 166px;
    max-width: 166px;
    width: 166px;
    font-size: 12px;
    font-weight: bold;
  }

  ::v-deep .InputLayout__slot {
    width: 100%;
    .multiselect {
      width: 100%;
    }
  }

  ::v-deep .multiselect--disabled {
    background: none;

    .multiselect__select {
      background: none;
    }
  }
}
</style>
